import { transformRecordToOption } from '@/utils/common';

export const enableStatusRecord: Record<Api.Common.EnableStatus, App.I18n.I18nKey> = {
  '1': 'page.manage.common.status.enable',
  '2': 'page.manage.common.status.disable'
};

export const enableStatusOptions = transformRecordToOption(enableStatusRecord);

export const userGenderRecord: Record<any, App.I18n.I18nKey> = {
  '1': 'page.manage.user.gender.male',
  '2': 'page.manage.user.gender.female'
};

export const userGenderOptions = transformRecordToOption(userGenderRecord);

export const menuTypeRecord: Record<any, App.I18n.I18nKey> = {
  '1': 'page.manage.menu.type.directory',
  '2': 'page.manage.menu.type.menu'
};

export const menuTypeOptions = transformRecordToOption(menuTypeRecord);

export const menuIconTypeRecord: Record<any, App.I18n.I18nKey> = {
  '1': 'page.manage.menu.iconType.iconify',
  '2': 'page.manage.menu.iconType.local'
};

export const menuIconTypeOptions = transformRecordToOption(menuIconTypeRecord);

/**
 * Activation credit grant amounts (Tomans / IRT).
 *
 * These are DISPLAY-ONLY marketing figures. The backend is the source of truth
 * for the credit that is actually applied — the frontend only communicates the
 * offer so users know what to expect:
 *
 * - New users who register with a verified phone receive the full grant
 *   (`TOTAL_IRT`).
 * - Users who registered with email only receive `EMAIL_BASE_IRT` up front.
 * - When an email-registered user later verifies / adds a phone, they receive
 *   `PHONE_TOPUP_IRT` so their balance reaches `TOTAL_IRT`.
 *
 * Invariant: `EMAIL_BASE_IRT + PHONE_TOPUP_IRT === TOTAL_IRT`.
 */
export const ACTIVATION_GRANT = {
  /** Full activation grant for a phone-verified account. */
  TOTAL_IRT: 200000,
  /** Top-up granted when an email-registered user adds/verifies a phone. */
  PHONE_TOPUP_IRT: 175000,
  /** Base grant given on email-only registration. */
  EMAIL_BASE_IRT: 25000
} as const;
